import React from 'react'
import AssistChip from 'LuxKit/Chips/AssistChip'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import LineExcursionIcon from 'LuxKit/Icons/line/LineExcursionIcon'
import Group from 'components/utils/Group'
import type { GeoPlace } from 'tripPlanner/types/common'

interface Props {
  place: GeoPlace
  className?: string
}

function PlaceActionChips({
  place,

  className,
}: Props) {
  return (
    <Group
      direction="horizontal"
      gap={8}
      wrap="wrap"
      className={className}
      noDisplayWhenEmpty
    >
      {place.internationalPhoneNumber && (
        <AssistChip
          variant="filled"
          href={`tel:${place.internationalPhoneNumber}`}
          startIcon={<LinePhoneIcon />}
          size="small"
        >
          Call
        </AssistChip>
      )}
      {place.website && (
        <AssistChip
          variant="filled"
          href={place.website}
          startIcon={<LineExcursionIcon />}
          size="small"
          target="_blank"
        >
          Website
        </AssistChip>
      )}
    </Group>
  )
}

export default PlaceActionChips
